import React from 'react';
import ReactDOM from 'react-dom';
import Layout from './layout/';

const render = function render() {
    /* eslint-disable */
    ReactDOM.render(<Layout content={allData} />, document.getElementById('root'));
    /* eslint-enable */
};

render();
